<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    botAdmins () {
      return Object
        .values(this.$store.state.dict.admins)
        .filter(admin => admin.isBot);
    },
  },
  methods: {
    handleChangeAt (username) {
      return value => {
        this.$emit('change', {
          ...this.value,
          [username]: value,
        });
      };
    },
  },
  render () {
    return (
      <u-table>
        {this.botAdmins.map(admin => (
          <u-tr key={admin.id}>
            <u-td>
              {admin.username}
            </u-td>
            <u-td>
              <u-input
                fullwidth
                value={this.value[admin.username] || ''}
                onInput={this.handleChangeAt(admin.username)}
              />
            </u-td>
          </u-tr>
        ))}
      </u-table>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';
</style>
